"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { useTranslations } from "next-intl";
import { TextButton } from "@repo/ui/text-button";
import { cn } from "@repo/ui/utils";
import { LISTING_TYPE_CONFIGS } from "./directory-listing.config";
import { DirectoryFilterBar } from "./directory-filter-bar.component";
import { DirectoryToolbar } from "./directory-toolbar.component";
import { DirectoryAlphabetBar, DirectoryAlphabetBarSkeleton } from "./directory-alphabet-bar.component";
import { DirectoryFilterDialog } from "./directory-filter-dialog.component";
import { DirectoryStatusBar } from "./directory-status-bar.component";
import { DirectoryCardGrid } from "./directory-card-grid.component";
import { DirectoryEmptyState } from "./directory-empty-state.component";
import type { DirectoryListingViewProps } from "./directory-listing.types";
function TimeFilterTabs(t0) {
  const $ = _c(23);
  const {
    active,
    onChange
  } = t0;
  const t = useTranslations("directory");
  let t1;
  if ($[0] !== onChange) {
    t1 = () => onChange("upcoming");
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = active === "upcoming" ? "border-b-2 border-text-primary text-text-primary" : "text-text-secondary hover:text-text-primary";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("cursor-pointer py-5 typography-component-sm-medium transition-colors", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("upcomingEvents");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t3 || $[8] !== t4) {
    t5 = <button type="button" onClick={t1} className={t3}>{t4}</button>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onChange) {
    t6 = () => onChange("past");
    $[10] = onChange;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = active === "past" ? "border-b-2 border-text-primary text-text-primary" : "text-text-secondary hover:text-text-primary";
  let t8;
  if ($[12] !== t7) {
    t8 = cn("cursor-pointer py-5 typography-component-sm-medium transition-colors", t7);
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t) {
    t9 = t("pastEvents");
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t8 || $[18] !== t9) {
    t10 = <button type="button" onClick={t6} className={t8}>{t9}</button>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t5) {
    t11 = <div className="col-span-full flex gap-9 border-b border-border-subtle">{t5}{t10}</div>;
    $[20] = t10;
    $[21] = t5;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}
export function DirectoryListingView(t0) {
  const $ = _c(68);
  const {
    items,
    total,
    categoryOptions,
    filterGroups,
    availableLetters,
    listingType,
    hasMore,
    isPending,
    onCategoryToggle,
    onClearFilters,
    onSearchChange,
    onLoadMore,
    selectedCategories,
    selectedFilters,
    searchQuery,
    letterFilter,
    onLetterSelect,
    onApplyFilters,
    onFilterToggle,
    dateFrom,
    dateTo,
    onDateRangeChange,
    hasDateFilter,
    hasTimeFilter,
    hideAlphabetBar,
    timeFilter,
    onTimeFilterChange,
    hasHeader: t1,
    categoryMenu,
    categoryMenuAllHref
  } = t0;
  const hasHeader = t1 === undefined ? false : t1;
  const t = useTranslations("directory");
  const config = LISTING_TYPE_CONFIGS[listingType];
  const hasSelectedFilters = Object.values(selectedFilters).some(_temp);
  const hasActiveFilters = selectedCategories.size > 0 || hasSelectedFilters || searchQuery.length > 0 || dateFrom != null || dateTo != null || letterFilter != null && letterFilter.length > 0;
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const isSearching = searchQuery.trim().length > 0;
  const t2 = !hasHeader && "pt-8 desktop:pt-10";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("pb-8 desktop:pb-10", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== availableLetters || $[3] !== categoryMenu || $[4] !== categoryMenuAllHref || $[5] !== categoryOptions || $[6] !== config.filterLayout || $[7] !== config.label || $[8] !== dateFrom || $[9] !== dateTo || $[10] !== filterDialogOpen || $[11] !== filterGroups || $[12] !== hasDateFilter || $[13] !== hasTimeFilter || $[14] !== hideAlphabetBar || $[15] !== isSearching || $[16] !== letterFilter || $[17] !== onApplyFilters || $[18] !== onCategoryToggle || $[19] !== onClearFilters || $[20] !== onDateRangeChange || $[21] !== onFilterToggle || $[22] !== onLetterSelect || $[23] !== onSearchChange || $[24] !== onTimeFilterChange || $[25] !== searchQuery || $[26] !== selectedCategories || $[27] !== selectedFilters || $[28] !== timeFilter || $[29] !== total) {
    t4 = config.filterLayout === "pills" ? <DirectoryFilterBar categoryOptions={categoryOptions} selectedCategories={selectedCategories} searchQuery={searchQuery} searchLabel={config.label} onCategoryToggle={onCategoryToggle} onClearFilters={onClearFilters} onSearchChange={onSearchChange} categoryMenu={categoryMenu} categoryMenuAllHref={categoryMenuAllHref} /> : <>{hasTimeFilter && <TimeFilterTabs active={timeFilter} onChange={onTimeFilterChange} />}<DirectoryToolbar categoryOptions={categoryOptions} filterGroups={filterGroups} selectedCategories={selectedCategories} selectedFilters={selectedFilters} searchQuery={searchQuery} searchLabel={config.label} onFilterClick={() => setFilterDialogOpen(true)} onCategoryRemove={onCategoryToggle} onFilterRemove={onFilterToggle} onClearFilters={onClearFilters} onSearchChange={onSearchChange} dateFrom={dateFrom} dateTo={dateTo} hasDateFilter={hasDateFilter} onDateRangeChange={onDateRangeChange} />{!hideAlphabetBar && !isSearching ? availableLetters.length > 0 ? <DirectoryAlphabetBar activeLetter={letterFilter ?? null} onLetterSelect={onLetterSelect} availableLetters={availableLetters} /> : total > 0 ? <DirectoryAlphabetBarSkeleton /> : null : null}<DirectoryFilterDialog open={filterDialogOpen} onOpenChange={setFilterDialogOpen} categoryOptions={categoryOptions} filterGroups={filterGroups} selectedCategories={selectedCategories} selectedFilters={selectedFilters} onApply={onApplyFilters} onClear={onClearFilters} hasDateFilter={hasDateFilter} dateFrom={dateFrom} dateTo={dateTo} /></>;
    $[2] = availableLetters;
    $[3] = categoryMenu;
    $[4] = categoryMenuAllHref;
    $[5] = categoryOptions;
    $[6] = config.filterLayout;
    $[7] = config.label;
    $[8] = dateFrom;
    $[9] = dateTo;
    $[10] = filterDialogOpen;
    $[11] = filterGroups;
    $[12] = hasDateFilter;
    $[13] = hasTimeFilter;
    $[14] = hideAlphabetBar;
    $[15] = isSearching;
    $[16] = letterFilter;
    $[17] = onApplyFilters;
    $[18] = onCategoryToggle;
    $[19] = onClearFilters;
    $[20] = onDateRangeChange;
    $[21] = onFilterToggle;
    $[22] = onLetterSelect;
    $[23] = onSearchChange;
    $[24] = onTimeFilterChange;
    $[25] = searchQuery;
    $[26] = selectedCategories;
    $[27] = selectedFilters;
    $[28] = timeFilter;
    $[29] = total;
    $[30] = t4;
  } else {
    t4 = $[30];
  }
  let t5;
  if ($[31] !== config.hideStatusBar || $[32] !== config.label || $[33] !== hasActiveFilters || $[34] !== isPending || $[35] !== onClearFilters || $[36] !== total) {
    t5 = !config.hideStatusBar && <DirectoryStatusBar hasActiveFilters={hasActiveFilters} isPending={isPending} total={total} label={config.label} onClearFilters={onClearFilters} />;
    $[31] = config.hideStatusBar;
    $[32] = config.label;
    $[33] = hasActiveFilters;
    $[34] = isPending;
    $[35] = onClearFilters;
    $[36] = total;
    $[37] = t5;
  } else {
    t5 = $[37];
  }
  let t6;
  if ($[38] !== config.featuredFirstRow || $[39] !== config.mapToCardProps || $[40] !== isPending || $[41] !== items) {
    t6 = <DirectoryCardGrid items={items} mapToCardProps={config.mapToCardProps} isPending={isPending} featuredFirstRow={config.featuredFirstRow} />;
    $[38] = config.featuredFirstRow;
    $[39] = config.mapToCardProps;
    $[40] = isPending;
    $[41] = items;
    $[42] = t6;
  } else {
    t6 = $[42];
  }
  let t7;
  if ($[43] !== config.label || $[44] !== hasActiveFilters || $[45] !== isPending || $[46] !== items || $[47] !== onClearFilters) {
    t7 = !isPending && items.length === 0 && <DirectoryEmptyState label={config.label} hasActiveFilters={hasActiveFilters} onClearFilters={onClearFilters} />;
    $[43] = config.label;
    $[44] = hasActiveFilters;
    $[45] = isPending;
    $[46] = items;
    $[47] = onClearFilters;
    $[48] = t7;
  } else {
    t7 = $[48];
  }
  let t8;
  if ($[49] !== hasMore || $[50] !== isPending || $[51] !== onLoadMore || $[52] !== t) {
    t8 = hasMore && !isPending && <div className="col-span-full mt-10 flex justify-center tablet:mt-16"><TextButton iconRight={null} onClick={onLoadMore}>{t("viewMore")}</TextButton></div>;
    $[49] = hasMore;
    $[50] = isPending;
    $[51] = onLoadMore;
    $[52] = t;
    $[53] = t8;
  } else {
    t8 = $[53];
  }
  let t9;
  if ($[54] !== isPending || $[55] !== items || $[56] !== t) {
    t9 = isPending && items.length > 0 && <div className="col-span-full mt-10 flex justify-center tablet:mt-16"><p className="typography-body-sm-regular text-text-secondary">{t("loadingMore")}</p></div>;
    $[54] = isPending;
    $[55] = items;
    $[56] = t;
    $[57] = t9;
  } else {
    t9 = $[57];
  }
  let t10;
  if ($[58] !== t4 || $[59] !== t5 || $[60] !== t6 || $[61] !== t7 || $[62] !== t8 || $[63] !== t9) {
    t10 = <div className="container-grid gap-y-10">{t4}{t5}{t6}{t7}{t8}{t9}</div>;
    $[58] = t4;
    $[59] = t5;
    $[60] = t6;
    $[61] = t7;
    $[62] = t8;
    $[63] = t9;
    $[64] = t10;
  } else {
    t10 = $[64];
  }
  let t11;
  if ($[65] !== t10 || $[66] !== t3) {
    t11 = <section data-testid="directory-listing" className={t3}>{t10}</section>;
    $[65] = t10;
    $[66] = t3;
    $[67] = t11;
  } else {
    t11 = $[67];
  }
  return t11;
}
function _temp(s) {
  return s.size > 0;
}